import { render, staticRenderFns } from "./VehiclesTable.vue?vue&type=template&id=b5b1f64c&"
import script from "./VehiclesTable.vue?vue&type=script&lang=ts&"
export * from "./VehiclesTable.vue?vue&type=script&lang=ts&"
import style0 from "./VehiclesTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VDataTable,VImg})
